import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "cgmt_admin_token";

export const authApi = axios.create({ baseURL: API });

authApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  localStorage.setItem(TOKEN_KEY, data.token);
  return data.admin;
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getCurrentAdmin = async () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  try {
    const { data } = await authApi.get("/admin/me");
    return data.admin;
  } catch {
    localStorage.removeItem(TOKEN_KEY);
    return null;
  }
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
};
